import React from 'react';
import urls from '../configs/urls'
import '../css/App.css';
import ls from 'local-storage'
import axios from 'axios';
import Loading from "./Loading";

class Signup extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            first_name: '',
            last_name: '',
        };
        this.setFirstName = this.setFirstName.bind(this);
        this.setLastName = this.setLastName.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    componentDidMount() {

    }


    render() {
        return (
            <div className="App">
                <div className="App-body bg-white">
                    <form onSubmit={this.handleSubmit}>
                        <h5 className={"title"}>ثبت نام در آسونه</h5>
                        <h6 className={"title2"}>وارد کردن نام و نام خانوادگی صحیح الزامی است</h6>
                        <div style={{width:"100%",overflow:"hidden"}}>
                            <input type="text"
                                   value={this.state.first_name}
                                   onChange={this.setFirstName}
                                   className={"signupInput"}
                                   placeholder={"نام"}
                            />
                            <input type="text"
                                   value={this.state.last_name}
                                   onChange={this.setLastName}
                                   className={"signupInput"}
                                   placeholder={"نام خانوادگی"}
                                   style={{marginTop:"10px"}}
                            />
                        </div>

                        <input type={"submit"} className={"btn submitPhone"} value={"تایید"}/>

                    </form>
                </div>
                <Loading loading={this.state.loading}/>
            </div>
        );
    }

    setFirstName(event){
        this.setState({first_name: event.target.value});
    }
    setLastName(event){
        this.setState({last_name: event.target.value});
    }
    handleSubmit(event){
        event.preventDefault();

        if(this.state.first_name.length == 0 || this.state.last_name.length == 0 ) {
            alert("لطفا نام و نام خانوادگی را وارد کنید.");
            return;
        }

        this.register();

    }
    register(){
        this.setState({loading:true});
        let data = {
            token:ls.get("token"),
            fnamelname:this.state.first_name + " " + this.state.last_name,
            city_id:ls.get("city_id"),
        };
        axios.post(urls.baseUrl+urls.register,data)
            .then(res => {
                if(res.data.code == 200){
                    ls.set("city_name",res.data.city_name);
                    this.props.history.push("/home");
                }
                else{
                    this.setState({loading:false});
                    alert(res.data.message);
                }
            })
    }
}

export default Signup;
